// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

export const useReturnSlipById = (returnSlipId: string) => {
    return useAppSelector(state => state.store.pages.returnSlip.returnSlipsById[returnSlipId] || null);
};
